export const config = {
    apiKey: "AIzaSyB5e-DhjmPnMeP4wZq5VetryTomL7IBN_k",
    authDomain: "les-talents-m.firebaseapp.com",
    databaseURL: "https://les-talents-m.firebaseio.com",
    projectId: "les-talents-m",
    storageBucket: "les-talents-m.appspot.com",
    messagingSenderId: "707694221273"
  };